module.exports = __webpack_public_path__ + "static/img/Y1D100.d678ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y1D100.png
// module id = G5zG
// module chunks = 2